import { Avatar, AvatarProps } from "@mui/material";
import useImageSize from "../../../hooks/global/useImageSize";

type BlogCardAvatar = { name?: string } & AvatarProps;

export const BlogCardAvatar = ({
  src,
  name = "",
  ...props
}: BlogCardAvatar) => {
  const [avatarUrl] = useImageSize({
    imageUrl: src,
    size: 500,
    isProfile: true,
    originalFormat: true,
  });

  return (
    <Avatar
      src={avatarUrl}
      {...props}
      sx={{
        width: "2.5rem",
        height: "2.5rem",
      }}
    >
      {name.split("")[0]}
    </Avatar>
  );
};
